import {ApiError} from '../errors/ApiError'
import {getFirebaseAuthHeaders} from './assetAuth'

type AssetType = 'background' | 'screenshot' | 'decal'

/** Upload an image asset to S3 via the backend. Returns the S3 key and a presigned URL. */
export const uploadAsset = async (file: File, type?: AssetType): Promise<{key: string; url: string}> => {
  const formData = new FormData()
  formData.append('file', file)

  const headers = await getFirebaseAuthHeaders()

  const params = type ? `?type=${type}` : ''
  const url = `/api/assets/upload${params}`
  const response = await fetch(url, {method: 'POST', headers, body: formData})

  if (!response.ok) {
    const body = await response.json().catch(() => ({}))
    const message = (body as {message?: string}).message ?? `Upload failed: ${response.status}`
    // Throw ApiError (not a plain Error) so handleApiError surfaces meaningful 4xx
    // messages — e.g. the 413 "Storage quota exceeded" reason during save.
    throw new ApiError(response.status, message, body, 'POST', url)
  }

  const data = (await response.json()) as {key: string; url: string}
  return data
}
